export default "__VITE_ASSET__CDzNnpWb__"